export default "__VITE_PUBLIC_ASSET__c4fed21c__"